module.exports = __webpack_public_path__ + "static/img/join_us02.23ca1974.jpg";